import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  message: string;
  confirmButtonText: string;
  cancelButtonText: string;
  okButtonVisible = true;
  cancelButtonVisible = true;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
    if (data) {
      this.message = data.message || this.message;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
      if (data.buttonVisible) {
        this.okButtonVisible = data.buttonVisible.ok;
        this.cancelButtonVisible = data.buttonVisible.cancel;
      }
    }
  }

  onConfirmClick(selectedValue: boolean): void {
    this.dialogRef.close(selectedValue);
  }
}
